import axios from 'axios';
import * as types from './actionTypes';
import * as urls from './urlTypes';
import { _getSampleWeightedParams } from '../util/deUtils';
import { getDefinitionSampleWt } from './deActions/deImportDefActions';

// Thunks - actions that return a function that accepts a dispatch
export function getDefinitionTreeLoad(
  token,
  ssid,
  accountId,
  productNo,
  sort = 'defSort=sc-a,lb-a,id-d',
  esSearch
) {
  let url = `${urls.API_GATEWAY_URL}/api/dictionary-service/definitions/${accountId}/${ssid}/${productNo}?${sort}`;
  if (esSearch) {
    url = `${url}&es=${esSearch}`
  }
  return dispatch => {
    axios({
      url,
      method: 'get',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
    })
      .then(response =>
        dispatch({
          type: types.GET_DEFINITION_TREE_LOAD,
          payload: response.data,
          productNo,
        })
      )
      .catch(response => console.warn(response));
  };
}

// Thunks - actions that return a function that accepts a dispatch
export function getDefinitionTreeListLoad(ssid, accountId, productNo) {
  const url = `${urls.API_GATEWAY_URL}/api/dictionary-service/definitions/expressions/${accountId}/${ssid}/${productNo}`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
    })
      .then(response =>
        dispatch({
          type: types.GET_DEFINITION_TREE_LIST_LOAD,
          payload: response.data,
          productNo,
        })
      )
      .catch(response => console.warn(response));
  };
}

export const getDefinitionTargetLoadWithPct = (
  data,
  accountId,
  userId,
  study,
  selectedWeightType
) => async dispatch => {
  const expressionList = data;
  if (data.data.length) {
    const sampleWeightedParams = await _getSampleWeightedParams(
      expressionList.data,
      study,
      accountId,
      userId,
      selectedWeightType
    );
    const targetSampleWeighted = await getDefinitionSampleWt(
      sampleWeightedParams
    );
    if (targetSampleWeighted.length) {
      targetSampleWeighted.map((item, i) => {
        expressionList.data[i].display = item !== null;
      });
      dispatch({
        type: types.GET_DEFINITION_TARGET_LOAD,
        payload: expressionList,
      });
    }
  } else {
    dispatch({
      type: types.GET_DEFINITION_TARGET_LOAD,
      payload: [],
    });
  }
};

export const getDefinitionTargetLoad = (
  accountId,
  definitionId,
  study,
  selectedWeightType,
  isComposer
) => async (dispatch, getState) => {
  const url = `${urls.API_GATEWAY_URL}/api/dictionary-service/definitions/expressions/${accountId}/${definitionId}`;
  const state = getState();
  const userId = state.login.loginResponse.data.uid;
  try {
    const response = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });
    if (response.data) {
      if (isComposer) {
        dispatch(
          getDefinitionTargetLoadWithPct(
            response.data,
            accountId,
            userId,
            study,
            selectedWeightType
          )
        );
      } else {
        dispatch({
          type: types.GET_DEFINITION_TARGET_LOAD,
          payload: response.data,
        });
      }
      return response.data;
    }
    return false;
  } catch (error) {
    return false;
  }
};

// Thunks - actions that return a function that accepts a dispatch
export function createNewDefinition({
  token,
  ssid,
  accountId,
  productNo,
  thisStudy,
  folderName,
  shared,
  newExpressions,
  sort,
  // refreshDefinitions,
}) {
  const url = `${urls.API_GATEWAY_URL}/api/dictionary-service/definitions/${accountId}/${ssid}`;
  return dispatch =>
    new Promise((resolve, reject) => {
      axios({
        url,
        method: 'post',
        headers: {
          accept: 'application/json;charset=UTF-8',
        },
        withCredentials: true,
        responseType: 'json',
        data: {
          productNo,
          folderName,
          shared,
          newExpressions,
          global: !thisStudy,
        },
      })
        .then(response => {
          // if (refreshDefinitions) {
          if (response.status === 200) {
            dispatch(
              getDefinitionTreeLoad(token, ssid, accountId, productNo, sort)
            );
            resolve(true);
          }
          // }
        })
        .catch(error => {
          reject(error.toJSON());
        });
    });
}

// Thunks - actions that return a function that accepts a dispatch
export function deleteDefinition(
  token,
  ssid,
  accountId,
  productNo,
  definitionId
) {
  const url = `${urls.API_GATEWAY_URL}/api/dictionary-service/definitions/${accountId}/${ssid}/${definitionId}`;
  return dispatch => {
    axios({
      url,
      method: 'delete',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
    })
      .then(() => {
        dispatch({
          type: types.DELETE_DEFINITION_TARGET,
        });
        dispatch(getDefinitionTreeLoad(token, ssid, accountId, productNo));
      })
      .catch(response => console.warn(response));
  };
}

export function deleteSharedDefinition(
  token,
  ssid,
  accountId,
  productNo,
  definitionId
) {
  const url = `${urls.API_GATEWAY_URL}/api/dictionary-service/definitions/adoption/${accountId}/${ssid}/${definitionId}`;
  return dispatch => {
    axios({
      url,
      method: 'delete',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
    })
      .then(() => {
        dispatch({
          type: types.DELETE_DEFINITION_TARGET,
        });
        dispatch(getDefinitionTreeLoad(token, ssid, accountId, productNo));
      })
      .catch(response => console.warn(response));
  };
}

// Thunks - actions that return a function that accepts a dispatch
export function patchTargetFolder({
  token,
  ssid,
  accountId,
  productNo,
  definitionId,
  thisStudy,
  folderName,
  shared,
  deletes,
  newExpressions,
  // refreshDefinitions,
}) {
  const url = `${urls.API_GATEWAY_URL}/api/dictionary-service/definitions/${accountId}/${ssid}/${definitionId}`;
  return dispatch =>
    new Promise((resolve, reject) => {
      axios({
        url,
        method: 'put',
        headers: {
          accept: 'application/json;charset=UTF-8',
        },
        withCredentials: true,
        data: {
          folderName,
          deletes,
          productNo,
          shared,
          newExpressions,
          global: !thisStudy,
        },
        responseType: 'json',
      })
        .then(response => {
          // if (refreshDefinitions) {
          if (response.status === 200) {
            dispatch(getDefinitionTreeLoad(token, ssid, accountId, productNo));
            resolve(true);
          }
          // }
        })
        .catch(error => reject(error.toJSON()));
    });
}

// Thunks - actions that return a function that accepts a dispatch
export function getSharedList(accountId) {
  const url = `${urls.API_GATEWAY_URL}/api/dictionary-service/definitions/listShared/${accountId}`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
    })
      .then(response =>
        dispatch({
          type: types.GET_SHARED_DEFINITION_LIST,
          payload: response.data,
        })
      )
      .catch(response => console.warn(response));
  };
}

// Thunks - actions that return a function that accepts a dispatch
export function adoptSharedFolder(
  token,
  uid,
  accountId,
  productNo,
  ssid,
  BulkSharedFolder
) {
  const url = `${urls.API_GATEWAY_URL}/api/dictionary-service/definitions/bulk/${accountId}/${ssid}`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: BulkSharedFolder,
    })
      .then(() =>
        dispatch(getDefinitionTreeLoad(token, ssid, accountId, productNo))
      )
      .catch(response => console.warn(response));
  };
}

export const clearDefinitionTarget = () => ({
  type: types.DELETE_DEFINITION_TARGET,
});

export function deleteDefinitions({
  ssid,
  accountId,
  expressionId,
  definitionFolderId,
  moduleStudy,
  selectedWeightType,
}) {
  // eslint-disable-next-line max-len
  const url = `${urls.API_GATEWAY_URL}/api/dictionary-service/definitions/expressions/delete/${accountId}/${ssid}/${definitionFolderId}`;

  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: [Number(expressionId)],
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(
            getDefinitionTargetLoad(
              accountId,
              definitionFolderId,
              moduleStudy,
              selectedWeightType,
              true
            )
          );
        }
      })
      .catch(response => console.warn(response));
  };
}
